import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { FormControl, Select } from '@ha/dsl';
import { useIntl } from 'ha/i18n';
import { MenuItem } from 'ha/components/Menu/MenuItem';
import { FreePlacesValue } from 'ha/types/SearchFilters';

interface Props {
  value: FreePlacesValue;
  onChange: (value: FreePlacesValue) => void;
}

const useStyles = makeStyles()(theme => ({
  defaultValueSelect: {
    color: theme.palette.grey['400'],
  },
  defaultValueOption: {
    display: 'none',
  },
}));

const FreePlacesFilter: React.FC<Props> = ({ value, onChange }) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  const handleFreePlacesChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value as FreePlacesValue);
    },
    [onChange],
  );

  const handleFreePlacesClosed = React.useCallback(() => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }, []);

  const isDefaultFreePlaces = value === FreePlacesValue.ZERO;

  return (
    <FormControl margin="dense" fullWidth variant="outlined" hiddenLabel>
      <Select
        margin="dense"
        value={value}
        onChange={handleFreePlacesChange}
        className={isDefaultFreePlaces ? classes.defaultValueSelect : undefined}
        MenuProps={{
          TransitionProps: {
            onExited: handleFreePlacesClosed,
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        }}
      >
        <MenuItem
          value={FreePlacesValue.ZERO}
          disabled
          className={classes.defaultValueOption}
        >
          {T('ukr_response.search.select_free_places')}
        </MenuItem>
        <MenuItem value={FreePlacesValue.ONE}>1</MenuItem>
        <MenuItem value={FreePlacesValue.TWO}>2</MenuItem>
        <MenuItem value={FreePlacesValue.THREE}>3</MenuItem>
        <MenuItem value={FreePlacesValue.FOUR}>4</MenuItem>
        <MenuItem value={FreePlacesValue.FIVE_AND_MORE}>5+</MenuItem>
      </Select>
    </FormControl>
  );
};

export { FreePlacesFilter };
